//
// client-mgmt-api-service.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

/* global angular: false */

((() => {
    angular.module('curalate').service('ClientMgmtApiService', ['$http', '$q', 'PromiseService', function($http, $q, PromiseService) {
        const BASE_URL = '/api/client-mgmt';

        this.asyncPacmanHealthCheck = () => PromiseService.processHttpResponse($http.get(`${BASE_URL}/pacman-healthcheck`));

        this.asyncRosettaHealthCheck = () => PromiseService.processHttpResponse($http.get(`${BASE_URL}/rosetta-healthcheck`));

        this.asyncDoesBVClientExist = clientName => PromiseService.processHttpResponse($http.get(`${BASE_URL}/bv-client-exists/${clientName}`));

        this.asyncGetBVClientRecord = (clientName, serviceName) => PromiseService.processHttpResponse($http.get(`${BASE_URL}/bv-client-record/${clientName}/${serviceName}`));

        this.asyncGetAnyBVClientRecord = clientName => PromiseService.processHttpResponse($http.get(`${BASE_URL}/bv-client-record/${clientName}`));

        this.asyncSearchBVClients = clientName => PromiseService.processHttpResponse($http.get(`${BASE_URL}/search-bv-clients/${clientName}`));

        this.asyncGetUsers = () => PromiseService.processHttpResponse($http.get(`${BASE_URL}/users`));

        this.asyncGetRegions = () => PromiseService.processHttpResponse($http.get(`${BASE_URL}/bv-regions`));

        this.asyncGetGroups = () => PromiseService.processHttpResponse($http.get(`${BASE_URL}/groups`));

        this.asyncGetClientsByGroup = groupId => PromiseService.processHttpResponse($http.get(`${BASE_URL}/clients-by-group/${groupId}`));

        this.asyncGetClientInfo = clientId => PromiseService.processHttpResponse($http.get(`${BASE_URL}/client-info/${clientId}`));

        this.asyncGetFunnelStages = filter => PromiseService.processHttpResponse($http.get(`${BASE_URL}/client-funnel-stages/${filter}`));

        this.asyncBuildIngestionEmailAddress = clientName => PromiseService.processHttpResponse(
                $http({
                    method: 'post',
                    url: `${BASE_URL}/ingestion-email`,
                    data: {
                        clientName,
                    },
                })
            );

        this.asyncGetIngestionEmailAddressAvailability = ingestionEmailAddress => PromiseService.processHttpResponse(
                $http({
                    method: 'post',
                    url: `${BASE_URL}/ingestion-email-availability`,
                    data: {
                        ingestionEmailAddress,
                    },
                })
            );

        this.asyncCreateClient = (
                funnelStage,
                brandName,
                createNewGroup,
                groupName,
                newGroupAdminCreateNewUser,
                newGroupAdminFirstName,
                newGroupAdminLastName,
                newGroupAdminEmail,
                ingestionEmailAddress,
                bvClientId,
                bvDisplayName,
                bvCluster,
                salesforceId,
                billingId
            ) => PromiseService.processHttpResponse(
                $http({
                    method: 'post',
                    url: `${BASE_URL}/create-client`,
                    data: {
                        funnelStage,
                        brandName,
                        createNewGroup,
                        groupName,
                        optionalGroupAdminCreateNewUser: newGroupAdminCreateNewUser,
                        optionalGroupAdminFirstName: newGroupAdminFirstName,
                        optionalGroupAdminLastName: newGroupAdminLastName,
                        optionalGroupAdminEmail: newGroupAdminEmail,
                        ingestionEmailAddress,
                        bvClientId,
                        bvDisplayName,
                        bvCluster,
                        optionalSalesforceId: salesforceId,
                        optionalBillingId: billingId,
                    },
                })
            );

        this.asyncModifyClient = (
                clientId,
                setExpiresOn,
                oldExpiresOnInMs,
                newExpiresOnInMs,
                setOwner,
                oldOwner,
                newOwner,
                setFunnelStage,
                oldFunnelStageString,
                newFunnelStageString,
                setBazaarvoiceClientId,
                oldBazaarvoiceClientId,
                newBazaarvoiceClientId,
                oldBvDisplayName,
                newBvDisplayName,
                oldBvCluster,
                newBvCluster,
                oldSalesforceId,
                newSalesforceId,
                oldBillingId,
                newBillingId
            ) => PromiseService.processHttpResponse(
                $http({
                    method: 'post',
                    url: `${BASE_URL}/modify-client`,
                    data: {
                        clientId,
                        setExpiresOn,
                        oldExpiresOnInMs,
                        newExpiresOnInMs,
                        setOwner,
                        oldOwner,
                        newOwner,
                        setFunnelStage,
                        oldFunnelStageString,
                        newFunnelStageString,
                        setBazaarvoiceClientId,
                        oldBazaarvoiceClientId,
                        newBazaarvoiceClientId,
                        oldBvDisplayName,
                        newBvDisplayName,
                        oldBvCluster,
                        newBvCluster,
                        oldSalesforceId,
                        newSalesforceId,
                        oldBillingId,
                        newBillingId,
                    },
                })
            );

        this.asyncCreateBVCurOnlyClient = (
            bvClientId,
            bvDisplayName,
            bvRegionId,
            salesforceId,
            billingId
        ) => PromiseService.processHttpResponse(
            $http({
                method: 'post',
                url: `${BASE_URL}/create-bv-cur-only-client`,
                data: {
                    provisioningType: 'CURALATE_ONLY',
                    clientDisplayName: bvDisplayName,
                    clientName: bvClientId,
                    salesforceID: salesforceId,
                    billingID: billingId,
                    regionID: bvRegionId,
                    requester: null,
                },
            })
        );
    },
    ]);
}))();
